(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('team-code', {
            parent: 'account',
            url: '/team-code',
            data: {
                authorities: [],
                pageTitle: 'teamCode.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/team-code/team-code.html',
                    controller: 'TeamCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('teamCode');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
